<template>
  <div class="app-content">
    <div v-for="tab in tabs" :key="tab.id + '-component'" style="position: relative; top: 0px;">
      <transition name="fade">
        <component :is="tab.component" v-bind="tab.props" v-if="tab.isActive" />
      </transition>
    </div>
  </div>
</template>

<script>
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import SubNavigationItem from '@/views/components/header/SubNavigationItem.vue';

import ReportsOfSicknessIndex from './ReportsOfSicknessIndex.vue';

import NewUwvDecision from '@/views/components/uwv-decision-new/NewUwvDecision.vue';

import NewReportOfSickness from '@/views/components/report-of-sickness-new/NewReportOfSickness.vue';
import EditReportOfSickness from '@/views/components/report-of-sickness-edit/EditReportOfSickness.vue';
import ReportOfSicknessDetails from '@/views/components/report-of-sickness-details/ReportOfSicknessDetails.vue';
import NewPeriod from '@/views/components/period-new/NewPeriod.vue';
import EditPeriod from '@/views/components/period-edit/EditPeriod.vue';
import NewRecovery from '@/views/components/recovery-new/NewRecovery.vue';
import EditRecovery from '@/views/components/recovery-edit/EditRecovery.vue';
import ReportsOfSicknessImport from '@/views/components/reports-of-sickness-import/ReportsOfSicknessImport.vue';
import ReportsOfSicknessImportNew from '@/views/components/reports-of-sickness-import-new/ReportsOfSicknessImportNew.vue';
export default {
  name: 'ReportsOfSickness',
  components: {
    Button,
    SubNavigationItem,
    ReportsOfSicknessIndex,

    NewReportOfSickness,
    EditReportOfSickness,
    ReportOfSicknessDetails,
    ReportsOfSicknessImport,
    ReportsOfSicknessImportNew,

    NewPeriod,
    EditPeriod,

    NewRecovery,
    EditRecovery,

    NewUwvDecision
  },
  computed: {
    tabs () {
      return this.$store.getters.reportsOfSicknessTabs;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
